import { useState, useEffect } from 'react';
import { useApp } from '../App';
import api from '../api';
import BackButton from '../components/BackButton';
import { useI18n } from '../i18n/index.jsx';

export default function Leaderboard() {
  const { user } = useApp();
  const { t } = useI18n();
  const [tab, setTab] = useState('referrals'); // referrals, turnover, xp
  const [data, setData] = useState([]);
  const [myRank, setMyRank] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    loadLeaderboard();
  }, [tab]);

  async function loadLeaderboard() {
    setLoading(true);
    try {
      const { data } = await api.get(`/leaderboard/${tab}`);
      setData(data.leaders || []);
      setMyRank(data.my_rank);
    } catch (e) {
      // Demo data
      setData([
        { rank: 1, name: 'Алексей М.', value: 47, avatar: '👑' },
        { rank: 2, name: 'Иван К.', value: 35, avatar: '🥈' },
        { rank: 3, name: 'Мария С.', value: 28, avatar: '🥉' },
        { rank: 4, name: 'Пётр В.', value: 21, avatar: '⭐' },
        { rank: 5, name: 'Анна Д.', value: 18, avatar: '⭐' },
        { rank: 6, name: 'Дмитрий Р.', value: 15, avatar: '💎' },
        { rank: 7, name: 'Ольга Н.', value: 12, avatar: '💎' },
        { rank: 8, name: 'Сергей Л.', value: 10, avatar: '🌟' },
        { rank: 9, name: 'Елена Б.', value: 8, avatar: '🌟' },
        { rank: 10, name: 'Николай Г.', value: 6, avatar: '🌟' },
      ]);
      setMyRank({ rank: 23, value: 3 });
    } finally {
      setLoading(false);
    }
  }

  const tabs = [
    { id: 'referrals', label: '👥 Рефералы', unit: 'чел.' },
    { id: 'turnover', label: '💰 Оборот', unit: 'PLN' },
    { id: 'xp', label: '⭐ Опыт', unit: 'XP' },
  ];

  const currentTab = tabs.find(t => opt.id === tab);

  if (loading) return <div className="page"><BackButton /><div className="loader">{t('common.loading')}</div></div>;

  return (
    <div className="page">
      <BackButton />
      <h1>🏅 Рейтинг</h1>

      {/* Tabs */}
      <div style={{ display: 'flex', gap: 8, marginBottom: 16 }}>
        {tabs.map(opt => (
          <button
            key={opt.id}
            className={`btn btn-small ${tab === opt.id ? 'btn-primary' : ''}`}
            style={{ flex: 1, background: tab === opt.id ? undefined : 'rgba(255,255,255,0.1)' }}
            onClick={() => setTab(opt.id)}
          >
            {opt.label}
          </button>
        ))}
      </div>

      {/* Top 3 Podium */}
      <div style={{
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'flex-end',
        gap: 8,
        marginBottom: 24,
        height: 180,
      }}>
        {/* 2nd place */}
        {data[1] && (
          <div style={{ textAlign: 'center', flex: 1 }}>
            <div style={{ fontSize: 32, marginBottom: 4 }}>🥈</div>
            <div style={{ fontWeight: 'bold', fontSize: 13 }}>{data[1].name}</div>
            <div style={{ fontSize: 12, opacity: 0.7 }}>{data[1].value.toLocaleString()} {currentTab.unit}</div>
            <div style={{
              height: 60,
              background: 'linear-gradient(180deg, #94a3b8, #64748b)',
              borderRadius: '8px 8px 0 0',
              marginTop: 8,
            }} />
          </div>
        )}
        
        {/* 1st place */}
        {data[0] && (
          <div style={{ textAlign: 'center', flex: 1 }}>
            <div style={{ fontSize: 48, marginBottom: 4 }}>👑</div>
            <div style={{ fontWeight: 'bold' }}>{data[0].name}</div>
            <div style={{ fontSize: 14, color: '#fbbf24' }}>{data[0].value.toLocaleString()} {currentTab.unit}</div>
            <div style={{
              height: 90,
              background: 'linear-gradient(180deg, #fbbf24, #f59e0b)',
              borderRadius: '8px 8px 0 0',
              marginTop: 8,
            }} />
          </div>
        )}
        
        {/* 3rd place */}
        {data[2] && (
          <div style={{ textAlign: 'center', flex: 1 }}>
            <div style={{ fontSize: 32, marginBottom: 4 }}>🥉</div>
            <div style={{ fontWeight: 'bold', fontSize: 13 }}>{data[2].name}</div>
            <div style={{ fontSize: 12, opacity: 0.7 }}>{data[2].value.toLocaleString()} {currentTab.unit}</div>
            <div style={{
              height: 40,
              background: 'linear-gradient(180deg, #c27c44, #a16207)',
              borderRadius: '8px 8px 0 0',
              marginTop: 8,
            }} />
          </div>
        )}
      </div>

      {/* My Rank */}
      {myRank && (
        <div style={{
          background: 'linear-gradient(135deg, #6366f1 0%, #8b5cf6 100%)',
          borderRadius: 12,
          padding: 16,
          marginBottom: 16,
          display: 'flex',
          justifyContent: 'space-between',
          alignItems: 'center',
        }}>
          <div>
            <div style={{ opacity: 0.8, fontSize: 12 }}>Твоё место</div>
            <div style={{ fontSize: 24, fontWeight: 'bold' }}>#{myRank.rank}</div>
          </div>
          <div style={{ textAlign: 'right' }}>
            <div style={{ opacity: 0.8, fontSize: 12 }}>Твой результат</div>
            <div style={{ fontSize: 18, fontWeight: 'bold' }}>{myRank.value.toLocaleString()} {currentTab.unit}</div>
          </div>
        </div>
      )}

      {/* Full List */}
      <h3>📋 Полный рейтинг</h3>
      <div className="list">
        {data.slice(3).map((item, i) => (
          <div key={i} style={{
            display: 'flex',
            justifyContent: 'space-between',
            alignItems: 'center',
            padding: '12px 0',
            borderBottom: '1px solid rgba(255,255,255,0.1)',
          }}>
            <div style={{ display: 'flex', alignItems: 'center', gap: 12 }}>
              <span style={{
                width: 32,
                height: 32,
                borderRadius: '50%',
                background: 'rgba(255,255,255,0.1)',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                fontWeight: 'bold',
              }}>
                {item.rank}
              </span>
              <span>{item.name}</span>
            </div>
            <span style={{ fontWeight: 'bold' }}>{item.value.toLocaleString()} {currentTab.unit}</span>
          </div>
        ))}
      </div>
    </div>
  );
}
